// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__6EilG","fields":"styles_fields__1zj66","forgotPassword":"styles_forgotPassword__zaCac"};